import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <circle cx="50" cy="50" r="40" stroke="currentColor" strokeWidth="5" fill="none" />
  </svg>
);

export default IconLoader;
